import { AccountFilled, RewardBronzeCircleColored, RewardSilverCircleColored, RewardGoldenCircleColored, RewardPlatinumCircleColored } from '@teko/ds-icon';
import React__default from 'react';
import { CommonStyles } from '../BaseProps/index.es.js';
import { Image } from '../Image/Image.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const MAPPING_SIZE = {
  s: 24,
  m: 32,
  l: 40,
  xl: 48
};
const MAPPING_REWARD_COMPONENT = {
  bronze: RewardBronzeCircleColored,
  silver: RewardSilverCircleColored,
  gold: RewardGoldenCircleColored,
  platinum: RewardPlatinumCircleColored
};
const Wrapper = styled.span`
  ${CommonStyles}
  position: relative;
  border-radius: 50%;
  width: ${(p) => p.size}px;
  height: ${(p) => p.size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(p) => p.backgroundColor ? p.theme.colors[p.backgroundColor] : "unset"};
`;
const TextIcon = styled.span`
  display: inline-block;
  font-size: ${(p) => p.size / 2}px;
  color: ${(p) => p.theme.colors[p.color]};
  text-align: center;
`;
const ImageIcon = styled(Image)`
  object-fit: cover;
  border-radius: 50%;
`;
const RewardIcon = styled.div`
  display: flex;
  position: absolute;
  bottom: 0;
  right: 0;
  background: transparent;
`;
const Avatar = (_a) => {
  var _b = _a, {
    size = "m",
    text,
    icon,
    src,
    color = "textSecondary",
    backgroundColor = "disable",
    showReward = false,
    rewardType = "gold",
    customRewardIcon
  } = _b, props = __objRest(_b, [
    "size",
    "text",
    "icon",
    "src",
    "color",
    "backgroundColor",
    "showReward",
    "rewardType",
    "customRewardIcon"
  ]);
  const actualSize = typeof size === "string" ? MAPPING_SIZE[size] : size;
  const renderChildren = () => {
    var _a2, _b2, _c, _d;
    if (!icon && !src && !text) {
      return /* @__PURE__ */ React__default.createElement(AccountFilled, {
        color: "disable",
        size: actualSize
      });
    }
    if (!!src) {
      return /* @__PURE__ */ React__default.createElement(ImageIcon, {
        src,
        width: actualSize,
        height: actualSize,
        alt: "avtSrc",
        googleImageParams: { width: actualSize * 2 }
      });
    }
    if (icon) {
      return React__default.cloneElement(icon, {
        size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? actualSize : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size,
        color: !((_c = icon == null ? void 0 : icon.props) == null ? void 0 : _c.color) ? color : (_d = icon == null ? void 0 : icon.props) == null ? void 0 : _d.color
      });
    }
    if (!!(text == null ? void 0 : text.length)) {
      return /* @__PURE__ */ React__default.createElement(TextIcon, {
        size: actualSize,
        color
      }, text[0]);
    }
  };
  const renderReward = () => {
    var _a2, _b2;
    if (!showReward && !customRewardIcon)
      return null;
    if (customRewardIcon)
      return /* @__PURE__ */ React__default.createElement(RewardIcon, null, React__default.cloneElement(customRewardIcon, {
        size: !((_a2 = customRewardIcon == null ? void 0 : customRewardIcon.props) == null ? void 0 : _a2.size) ? actualSize / 3 : (_b2 = customRewardIcon == null ? void 0 : customRewardIcon.props) == null ? void 0 : _b2.size
      }));
    const Comp = MAPPING_REWARD_COMPONENT[rewardType];
    return /* @__PURE__ */ React__default.createElement(RewardIcon, null, /* @__PURE__ */ React__default.createElement(Comp, {
      size: actualSize / 3
    }));
  };
  return /* @__PURE__ */ React__default.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    size: actualSize,
    backgroundColor: !!(text == null ? void 0 : text.length) && backgroundColor || void 0
  }), renderChildren(), renderReward());
};

export { Avatar };
